import React, { useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router';

import { LoansIframePaths } from 'app/configs/routesConfig/loansIframe';
import { loanApi } from 'app/services/api';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

const LoanApplicationIframeRedirectPage = ({ setIsLoading, isLoading }) => {
  const { replace } = useHistory();
  const { loanNumber } = useParams();

  const [isError, setIsError] = useState(false);

  useEffectSafeStrictMode(() => {
    setIsLoading(true);
    loanApi
      .getLoan({ loanNumber })
      .then(({ data: { loanId, applicationId } }) => {
        LoansIframePaths.loanApplicationManagement.navigateWith(
          replace,
          { loanId },
          { state: { loanId, applicationId } },
        );
      })
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [loanNumber, replace, setIsLoading]);

  if (!isLoading && isError) {
    return <Redirect to="/pages/errors/error-404" />;
  }

  return null;
};

LoanApplicationIframeRedirectPage.propTypes = {
  ...WithLoadingPropTypes,
};

export default withLoading(LoanApplicationIframeRedirectPage);
